import { SystemBase2 } from "@inter-ikea-core/core-toolbox";
import { ComponentIds, HierarchyUtils, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { getConnectorsComponent } from "@inter-ikea-storagetwo/range/dist/functions/componentGetters";
import { CEILING, ROOM_SURFACE, } from "@inter-ikea-storagetwo/range/dist/constants";
import RequireSizeAdjustmentComponent from "@inter-ikea-storagetwo/range/dist/components/RequireSizeAdjustmentComponent";
import { CONNECTOR_DOESNT_EXISTS } from "@inter-ikea-storagetwo/range/dist/constants/errors";
export default class RequestPostAdjustmentSystem extends SystemBase2 {
    constructor(core) {
        super(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID, COMPONENT_IDS.ROOM_CHANGED_COMPONENT);
        this.core = core;
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.id = "RequestPostAdjustmentSystem";
        this.updatePostHeight = (entity) => {
            if (!entity.hasComponent(COMPONENT_IDS.SECTION_COMPONENT))
                return;
            const children = HierarchyUtils.children(entity);
            const ceiling = HierarchyUtils.descendants(this.core.services.sceneManager.scene).find((e) => {
                var _a;
                return ((_a = e.getComponent(ComponentIds.DISPLAY_NAME_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.name) === CEILING;
            });
            if (!ceiling)
                throw new Error("no entity");
            const ceilingConnector = getConnectorsComponent(ceiling).getConnectorByKey(ROOM_SURFACE);
            if (!ceilingConnector)
                throw new Error(CONNECTOR_DOESNT_EXISTS);
            children.forEach((child) => child.addComponent(new RequireSizeAdjustmentComponent(ceiling, ceilingConnector)));
        };
    }
    onAddComponent(_entity) {
        this.updatePostHeight(_entity);
    }
    onAddComponent2() {
        const scene = this.core.services.sceneManager.scene;
        HierarchyUtils.getDescendantsWithComponent(scene, COMPONENT_IDS.SECTION_COMPONENT).forEach(this.updatePostHeight);
    }
}
